export default __webpack_public_path__ + "static/img-6-ad44f2f72300397b9c1c460417e04c37.png";